const createUserId = async (
  email: string,
  algorithm: 'SHA-1' | 'SHA-256' = 'SHA-1'
): Promise<string> => {
  const hashBuffer = await crypto.subtle?.digest(
    algorithm,
    toTypedArray(toLower(email)) as BufferSource
  )
  // eslint-disable-next-line es/no-typed-arrays
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')

  return hashHex
}

// eslint-disable-next-line es/no-typed-arrays
const toTypedArray = (str: string): Uint8Array => {
  return new TextEncoder().encode(str)
}

const toLower = (str: string): string => {
  return str.toLowerCase()
}

export { createUserId }
